

function Pricing(props) {
  return 'Pricing'
}
export default Pricing;